<template>
  <div class="clearAfterFloats">
    <div class="user-container clearAfterFloats">
      <!-- <DIALOGS> -->
      <!-- <USER CREATE OR UPDATE> -->
      <v-dialog v-model="cuDialog" width="850">
        <app-user-c-u
          class="dialog"
          @userChangedOrAdded="userChangedOrAdded"
          :isUpdate="isUpdate"
          :userId="editingUserId"
          :isModalOpen="cuDialog"
          @closeDialog="cuDialog = false"
        ></app-user-c-u>
      </v-dialog>
      <!-- </USER CREATE OR UPDATE> -->
      <!-- <USER FILTER> -->
      <v-dialog v-model="filterDialog" width="500">
        <app-filter
          class="dialog"
          :filterObject="filterObject"
          @filter="filterActivated"
          @closeDialog="filterDialog = false"
        ></app-filter>
      </v-dialog>
      <!-- </USER FILTER> -->
      <!-- </DIALOGS> -->
      <!-- Loading icon -->
      <img
        v-if="isLoading"
        class="loading-icon"
        src="../../assets/loading-icon.gif"
        alt="Loading..."
      />

      <div class="header clearAfterFloats">
        <h1 class="header-text">
          <span>
            Korisnici
            <div class="header-text-line"></div>
          </span>
        </h1>

        <!-- <USER SEARCH> -->
        <div class="user-search">
          <v-text-field
            @click:clear="resetFilterObject"
            clearable
            class="search-field"
            v-model="searchText"
            @keyup.enter="filterByName"
            label="Pretraga po imenu i/ili prezimenu"
          ></v-text-field>

          <v-btn
            @click="filterByName"
            class="search-btn"
          >
            <v-icon>search</v-icon>
            <span>Pretraga</span>
          </v-btn>
        </div>
        <!-- </USER SEARCH> -->
        <!-- <ACTIONS> -->
        <div class="actions">
          <img
            v-if="canEdit"
            class="action-icon"
            @click="
              userCreateClicked;
              cuDialog = true;
            "
            src="../../assets/icons/create.png"
            alt="Create user"
          />
          <img
            class="action-icon"
            @click="filterDialog = true"
            src="../../assets/icons/filter.png"
            alt="Filter user"
          />
          <div
            v-if="filterActive"
            class="clear-filter"
            @click="resetFilterObject"
            color="red lighten-2"
            dark
          >
            X Očisti filtere
          </div>
        </div>

        <!-- </ACTIONS> -->
      </div>
      <!-- <USER LIST> -->
      <div class="clearAfterFloats">
        <app-single
          v-for="user in users"
          :key="user.UserId"
          @userEditClicked="userEditClicked"
          :user="user"
        ></app-single>
      </div>
      <!-- </USER LIST> -->
    </div>

    <!-- <PAGINATION> -->
    <div class="text-xs-center pagination">
      <v-pagination
        :total-visible="5"
        @input="paginationActivated"
        v-model="filterObject.SelectedPage"
        :length="numberOfPages"
      ></v-pagination>
    </div>
    <!-- </PAGINATION> -->
  </div>
</template>

<script>
import CreateOrUpdate from "./CreateOrUpdate";
import Single from "./Single";
import Filter from "./Filter";
export default {
  components: {
    appUserCU: CreateOrUpdate,
    appSingle: Single,
    appFilter: Filter,
  },
  data() {
    return {
      canEdit: false,
      users: [],
      searchText: "",
      isSearchActive: false,
      filterObject: {
        SelectedPage: 1,
        IsActive: true,
        SelectedInstrument: 0,
        SelectedRole: 0,
      },
      filterActive: false,
      isUpdate: false,
      editingUserId: 0,
      isLoading: false,

      //pagination
      numberOfPages: 1,

      //dialogs
      cuDialog: false,
      filterDialog: false,
    };
  },
  methods: {
    getFilteredUsers() {
      this.isLoading = true;
      this.$store.state.services.userService
        .filter(this.filterObject)
        .then((response) => {
          this.isLoading = false;
          this.users = response.data.Users;
          this.numberOfPages = response.data.NumberOfPages;
          this.filterDialog = false;
          this.editingUserId = 0;
        })
        .catch((err) => {
          var responseMessage = {
            IsError: true,
            Message: "Problem sa konekcijom na server",
          };
          this.$store.dispatch("setResponseMessage", responseMessage);
          this.isLoading = false;
        });
    },
    getUsers() {
      this.isLoading = true;
      this.$store.state.services.userService
        .filterNoActivity(this.filterObject)
        .then((response) => {
          this.isLoading = false;
          this.users = response.data.Users;
          this.numberOfPages = response.data.NumberOfPages;
          this.filterDialog = false;
          this.editingUserId = 0;
        })
        .catch((err) => {
          var responseMessage = {
            IsError: true,
            Message: "Problem sa konekcijom na server",
          };
          this.$store.dispatch("setResponseMessage", responseMessage);
          this.isLoading = false;
        });
    },
    filterActivated() {
      this.filterActive = true;
      this.getFilteredUsers();
    },
    resetFilterObject() {
      this.filterObject.SelectedPage = 1;
      this.filterObject.IsActive = true;
      this.filterObject.SelectedInstrument = 0;
      this.filterObject.SelectedRole = 0;

      this.filterActive = false;
      this.isSearchActive = false;
      this.searchText = "";

      //Initial call after clear
      this.getUsers();
    },
    filterByName() {
      if (this.searchText.length == 0 || this.searchText === " ") return;
      this.isLoading = true;
      this.$store.state.services.userService
        .filterByName(this.searchText)
        .then((response) => {
          this.isLoading = false;
          this.users = response.data.Users;
          this.numberOfPages = response.data.NumberOfPages;
          this.isSearchActive = true;
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    paginationActivated() {
      if (this.filterActive) {
        this.getFilteredUsers();
      } else {
        this.getUsers();
      }
    },
    userCreateClicked() {
      this.isUpdate = false;
    },
    userEditClicked(userId) {
      this.isUpdate = true;
      this.editingUserId = userId;
      this.cuDialog = true;
    },
    userChangedOrAdded(response) {
      if (!response.IsError) {
        this.cuDialog = false;
        if (this.filterActive) {
          this.getFilteredUsers();
        } else {
          this.getUsers();
        }
      }
      this.$store.dispatch("setResponseMessage", response);
    },
  },
  created() {
    this.getUsers();
    this.canEdit = this.$store.state.services.checkRole("Administrator");
  },
  watch: {
    cuDialog() {
      if (this.cuDialog == false) {
        this.isUpdate = false;
      }
    },
  },
};
</script>

<style scoped>
.user-container {
  padding-bottom: 45px;
}
.dialog {
  background-color: white;
  position: relative;
}
.header-text {
  float: left;
  width: 25%;
}
.user-search {
  display: flex;
  justify-content: space-around;
  width: 50%;
  float: left;
}
.actions {
  width: 25%;
  float: right;
  text-align: right;
}
.action-icon {
  width: 35px;
  margin: 0 10px;
  cursor: pointer;
}
.pagination {
  position: absolute;
  bottom: 0;
  margin: 30px 0;
  width: 100%;
}
@media (max-width: 900px) {
  .header-text {
    width: 100%;
    margin-bottom: 15px;
  }
  .user-search {
    width: 100%;
  }
  .actions {
    margin-top: -120px;
    width: 50%;
  }
  .pagination {
    bottom: 0;
    left: 0;
    right: 0;
  }
}
</style>
